export default __webpack_public_path__ + "static/media/phone-call.c6a89fe5.svg";